import { withTriggerCombobox } from '@platejs/combobox'
import { createPlatePlugin } from 'platejs/react'
import type { AnyPlatePlugin } from 'platejs/react'

import { EmojiSearchElementUI } from './components'
import { EmojiElement, EmojiSearchElement } from './nodes'
import type { EmojiPluginOptions } from './types'

/**
 * Enables support for autocompleting emojis.
 */
// Not returned directly from the arrow function: an explicit return type on
// the expression itself back-propagates into createPlatePlugin's own
// generic inference and corrupts it (options/node end up typed against the
// annotation's defaults instead of the literal passed in).
export const createEmojiSearchPlugin = (overrides?: {
  options?: Pick<EmojiPluginOptions, 'maxSuggestions'>
}): AnyPlatePlugin => {
  const createdPlugin = createPlatePlugin({
    key: EmojiElement.type,
    node: { isLeaf: true },
    options: {
      id: EmojiSearchElement.type,
      insertSpaceAfterEmoji: true,
      trigger: EmojiSearchElement.trigger,
      triggerPreviousCharPattern: /^\s?$/,
      createComboboxInput: (trigger: string) => EmojiSearchElement.new(trigger),
      ...overrides?.options,
    },
    plugins: [
      createPlatePlugin({
        key: EmojiSearchElement.type,
        node: {
          isElement: true,
          isInline: true,
          isVoid: true,
          component: EmojiSearchElementUI,
        },
      }),
    ],
    // Plate's own BaseMentionPlugin casts the same way — createPlatePlugin's
    // generic inference and withTriggerCombobox's own generic don't unify.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }).overrideEditor(withTriggerCombobox as any)
  return createdPlugin
}
